export enum UserCurrency {
  USD = 'usd',
  EUR = 'eur',
  GBP = 'gbp',
}
